import CheckboxGroup from "@/components/CheckboxGroup";
import { BANK_NAME_MAP } from "@/constants/programs";
import useThemeData from "@/hooks/useThemeData";
import { renderBanksLogo } from "@/utils/commonRender";

import { useFilterContext } from "../FilterContext";

const FilterItemBanks = () => {
  const { filterData, setFilterData } = useFilterContext();

  const { isDarkMode } = useThemeData();
  return (
    <CheckboxGroup
      options={Object.values(BANK_NAME_MAP).map((item) => {
        return {
          value: item,
          label: item,
        };
      })}
      value={filterData.banks}
      onChange={(value) => {
        setFilterData({
          banks: value,
        });
      }}
      renderPrefix={(item) => renderBanksLogo(item.value, isDarkMode)}
    />
  );
};

export default FilterItemBanks;
